export const getFirebaseConfig = () => {
  return {
    apiKey: 'AIzaSyA3UdWcOTH_boeQPSTGOBdsF11lI37eUO8',
    authDomain: 'winter-monolith-92720.firebaseapp.com',
    databaseURL: 'https://winter-monolith-92720.firebaseio.com',
    projectId: 'winter-monolith-92720',
    storageBucket: 'winter-monolith-92720.appspot.com',
    messagingSenderId: '555458305584',
    appId: '1:555458305584:web:dbbc0d8c70ac4f5e3ed7f5',
    measurementId: 'G-1VHKF3FQ60',
  };
};

export const getVapidKey = () =>
  'BNsETnTqbiHHDfyzj0fAYj9-P0tuD62A7rFWAvttbruG3KEM3OExNPzNjbehxAP_9qVaRFxkyJzyoPLOAdGba1k';
